export default "__VITE_ASSET__DsAV5J7O__"